import { CarryOutOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import CreateTaskContent from 'automations/components/Nodes/CreateTaskContent';
import { type CreateTaskNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useCreateTask(node: NodeProps<CreateTaskNodeType>): ActionNodeReturnProps {
  const { data } = node;
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.CreateTaskActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <CreateTaskContent node={node} />, [node]);

  const subTitle = useMemo(() => {
    const baseData = data?.additionalOptions?.createTask;
    if (baseData?.subject) {
      return `Create Task: ${baseData.subject}`;
    }
    return null;
  }, [data?.additionalOptions?.createTask]);

  return {
    icon: CarryOutOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
    subTitle,
  };
}
